import { handleErrors } from "@/utils/handle-errors";
import { SdkApi } from "@/interfaces/sdk-api";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { SdkExceptLandingPage } from "@/interfaces/sdk-dictionary";

export const saveApi = (api: SdkApi) => ({ type: "saveApi", api });
export const updateApi = (api: SdkApi) => ({ type: "updateApi", api });
export const loadAllApis = (environmentId: number) => ({ type: "loadAllApis", environmentId });
export const deployApi = (id: number, environmentId: number) => ({ type: "deployApi", id, environmentId });
export const loadApi = (id: number) => ({ type: "loadApi", id });
export const deleteApi = (id: number) => ({ type: "deleteApi", id });
export const saveCheckLandingPageApis = (exceptLandingPage: SdkExceptLandingPage) => ({ type: "saveCheckLandingPageApis", exceptLandingPage });

export const actions = {
  loadAllApis(context: any, { environmentId }: { environmentId: number }) {
    return fetch(`core/api/apicustom/environment/${environmentId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  // TODO: Ajustar para tratar Blobs
  deployApi(context: any, { id, environmentId }: { id: number; environmentId: number }) {
    return fetch(`core/api/apicustom/${id}/export`, {
      method: "POST",
      body: JSON.stringify({ id: environmentId }),
    })
      .then(async (res: any) => {
        if (!res.ok) {
          res = await res.json();
          throw new Array(res.message);
        }
        return res.blob();
      })
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  loadApi(context: any, { id }: { id: number }) {
    return fetch(`core/api/apicustom/${id}`)
      .then(handleErrors)
      .then((data) => data);
  },

  saveApi(state: any, { api }: { api: SdkApi }) {
    return fetch(`core/api/apicustom`, {
      method: "POST",
      body: JSON.stringify(api),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updateApi(state: any, { api }: { api: SdkApi }) {
    return fetch(`core/api/apicustom`, {
      method: "PUT",
      body: JSON.stringify(api),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  deleteApi(state: any, { id }: { id: number }) {
    return fetch(`core/api/apicustom/${id}`, {
      method: "DELETE",
    }).then(handleErrors);
  },

  saveCheckLandingPageApis(state: any, { exceptLandingPage }: { exceptLandingPage: SdkExceptLandingPage }) {
    return fetch(`core/api/exceptlandingpage`, {
      method: "POST",
      body: JSON.stringify(exceptLandingPage),
    })
      .then(handleErrors)
      .then((data) => data);
  },
};
